module.exports = __webpack_public_path__ + "static/media/default-avatar.f03a4f8f.jpeg";